<template>
    <ErrorPage>
        <template slot="Title">
            This looks empty
        </template>
        <template slot="SubTitle">
        </template>
        <template slot="Content">
            Try creating your first clock then drag a music box in it!
        </template>
        <template slot="Actions">
            <ClockCreationButton :empty="false" />
        </template>
    </ErrorPage>
</template>

<script>
    import Button from'@/components/common/Button.vue'
    import ClockCreationButton from "./ClockCreationButton"
    import ErrorPage from'@/components/common/ErrorPage.vue'
    export default
        {
            name: "ClockListEmptyCard",
            components: {
                Button, ErrorPage, ClockCreationButton
            },
        }
</script>

<style scoped>
</style>